export default __webpack_public_path__ + "static/media/consensys-tachyon-logo.34fc4dd4.png";